var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"not-found"},[_c('p',{staticClass:"not-found__eyebrow"},[_vm._v("404")]),_c('h2',[_vm._v("页面不存在")]),_c('p',{staticClass:"not-found__desc"},[_vm._v("当前子应用中没有这个页面。")]),_c('router-link',{staticClass:"not-found__link",attrs:{"to":"/"}},[_vm._v("返回 Overview")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }